module.exports = __webpack_public_path__ + "img/membercard-green.892df08f.svg";